// Static brand content for Dr. Zeenal Punamiya

export const PROFILE = {
  name: "Dr. Zeenal Punamiya",
  firstName: "Zeenal",
  role: "Healthcare Innovation Leader",
  titles: [
    "Medical Innovation",
    "Applied Research",
    "Medical Writing",
    "Startup Mentorship",
  ],
  tagline:
    "I translate unmet clinical needs into validated, adoptable solutions — bridging clinicians, engineers, designers and industry.",
  intro:
    "Founder-scale leader of the M.I.C.E. Lab at Grant Government Medical College & Sir J.J. Hospital, Mumbai. Nine years across medical innovation, applied research, healthcare education and entrepreneurship.",
  email: "drzeenalpunamiya@gmail.com",
  phone: "+91 79771 79503",
  location: "Mumbai, India",
  primaryPhoto: "/assets/zeenal-primary.png",
  secondaryPhoto: "/assets/zeenal-secondary.jpeg",
  socials: {
    linkedin: "https://www.linkedin.com/in/drzeenalpunamiya",
    orcid: "https://orcid.org/0000-0002-7829-1165",
    whatsapp: "https://wa.me/917977179503",
  },
};

export const STATS = [
  { value: 5000, suffix: "+", label: "Innovators Mentored", sub: "Medicine · Engineering · Design" },
  { value: 20, suffix: "+", label: "Institutions Reached", sub: "Nationally, via hackathons & workshops" },
  { value: 9, suffix: " yrs", label: "In Medical Innovation", sub: "Clinical, research & education" },
  { value: 3, suffix: "", label: "Patents Filed", sub: "Incl. Indian patent · US in process" },
  { value: 3, suffix: "×", label: "MEDHA Hackathons Led", sub: "With BETIC Labs, IIT Bombay" },
  { value: 6, suffix: "", label: "Peer-Reviewed Works", sub: "Journals & book chapters" },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Clinical Grounding",
    body: "Every solution begins at the bedside. I stay close to the real clinical problem — because proximity to the pain point is the single biggest predictor of whether an innovation survives contact with the ward.",
  },
  {
    no: "02",
    title: "Applied Research",
    body: "My research sits where emerging technology meets healthcare and medical education — rigorously designed, peer-reviewed and published across international journals and book chapters. Rigour is not optional: an idea earns its place only when the evidence holds up and genuinely transfers into practice.",
  },
  {
    no: "03",
    title: "Program Leadership",
    body: "I built the M.I.C.E. Lab from zero inside a government hospital — operating model, governance, SOPs and program portfolio — then extended it from a single hospital to 20+ institutions nationally through hackathons, workshops and faculty exchange.",
  },
  {
    no: "04",
    title: "Translation & Impact",
    body: "From need-scouting to IP filing and clinical validation, I guide teams through the full lifecycle. Principal Investigator and patent holder for a stoma implant device — I help innovators cross the gap between a promising concept and an adoptable product.",
  },
];

export const EXPERTISE = [
  {
    icon: "Stethoscope",
    title: "Clinical Need Identification & Healthcare Problem Framing",
    body: "Scouting and sharply defining the real unmet needs on the ward — the foundation every strong innovation is built on.",
  },
  {
    icon: "Lightbulb",
    title: "MedTech Product Strategy & Clinical Validation",
    body: "Shaping product direction and validating concepts with clinicians so solutions are safe, usable and genuinely adoptable.",
  },
  {
    icon: "Rocket",
    title: "Consultation for MedTech Startups & Innovators",
    body: "Guiding early-stage teams through prototyping, funding schemes, IP and pitching to clinicians and investors.",
  },
  {
    icon: "GraduationCap",
    title: "Academic & Institutional Innovation Advisory",
    body: "Helping institutions build innovation programs, incubation capacity and a culture of applied research.",
  },
  {
    icon: "PenLine",
    title: "Medical Research, Writing & Thesis Support",
    body: "Support with study design, scientific writing, manuscripts, book chapters and thesis work toward peer-reviewed impact.",
  },
];

export const AFFILIATIONS = [
  "Grant Government Medical College",
  "Sir J.J. Group of Hospitals",
  "IIT Bombay — BETIC Labs",
  "Symbiosis Institute of Health Sciences",
  "American Heart Association",
  "Indian Medical Association — MSN",
  "MEDHA Medical Device Hackathon",
  "Smart India Hackathon",
];

export const CREDENTIALS = [
  { label: "PhD, Health Sciences", detail: "2021 – 2025" },
  { label: "PG Diploma, Hospital & Healthcare Management", detail: "2018 – 2019" },
  { label: "PG Diploma, Clinical Research", detail: "2018 – 2019" },
  { label: "M.Sc. Medical Technology — Anaesthesia & OT", detail: "2015 – 2017" },
  { label: "BLS & ACLS Instructor", detail: "American Heart Association" },
];

export const HONORS = [
  "1st Prize — Oral Presentation, 12th International Advanced Diagnostic Techniques Conference 2024",
  "Runner-Up — Maharashtra Medical Innovation Challenge, PULSE",
  "Prototype Funding — Ideathon 2.0 (Chitkara University, on behalf of DST India)",
  "Felicitated by former Finance Minister for 1st rank in Medical Technology, Symbiosis",
  "Evaluator — Smart India Hackathon 2023 & 2025",
  "Indian Patent Holder — Stoma Implant Device (US patent in process)",
];
